import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// 重要：必须最早 import，触发 localStorage monkey-patch，
// 让所有模块的 setItem/removeItem 都能进入同步管道
import './lib/sync.js';
import App from './App.jsx';
import { applyAllFlags } from './lib/flags.js';
import { applyStoredAccent } from './lib/accent.js';
import { applyStoredBg } from './lib/bg.js';
import { applyStoredUserBubble } from './lib/userBubble.js';
import { applyStoredTextColors } from './lib/textColor.js';
import './styles/tokens.css';
import './styles/global.css';

// Telegram 小程序收口（2026-08-14 铃报：从 TG 菜单打开时侧边栏底部显示不全）。
// TG 的 webview 可视区比 innerHeight 矮、底部还被 TG 自己的控件盖住 → 满屏定高的
// 浮层（侧边栏）底部会藏到控件后面、够不到。这里：①让 mini app 铺满高度；②把 TG
// 「保证稳定可见的高度」写进 --tg-vh，供 global.css 给这些浮层收口。只在 TG 内生效
// （platform!=='unknown'），普通浏览器/PWA 完全跳过、一点不动。
try {
  const tg = window.Telegram && window.Telegram.WebApp;
  if (tg && tg.platform && tg.platform !== 'unknown') {
    document.documentElement.classList.add('in-telegram');
    tg.ready();
    tg.expand();
    const applyVH = () => {
      const root = document.documentElement;
      // 稳定高度（不含键盘）：给满屏浮层（侧边栏等）收口用
      root.style.setProperty(
        '--tg-vh',
        (tg.viewportStableHeight || window.innerHeight) + 'px',
      );
      // 当前可视高度（键盘弹起会缩短）：给聊天外壳 .app-shell 用。
      // 2026-08-15 铃报：TG 迷你app 里一点输入框、键盘弹起就整页塌成背景——
      // 因为 .app-shell 那套 iOS 独立模式的 fixed top:0 + bottom:var(--kb)（靠
      // visualViewport 算键盘高）在 TG 的 webview 里算错、外壳被抬没了。改成直接
      // 用 TG 自己的 viewportHeight 定高，它本身已随键盘缩短，不需要再自己算。
      root.style.setProperty(
        '--tg-vh-live',
        (tg.viewportHeight || tg.viewportStableHeight || window.innerHeight) + 'px',
      );
    };
    applyVH();
    tg.onEvent('viewportChanged', applyVH);
  }
} catch (e) {
  /* 不在 TG 里 / SDK 没加载出来：静默跳过 */
}

// 首帧前把功能开关的当前值同步到 DOM（如 reduce_motion），避免刷新闪一下
applyAllFlags();
// 首帧前恢复强调色（同理，避免闪回金色）
applyStoredAccent();
// 首帧前恢复自选背景色（同理，避免闪回主题原底色）
applyStoredBg();
// 首帧前恢复自选气泡色（同理，避免闪回原紫/玫红）
applyStoredUserBubble();
// 首帧前恢复自选文字颜色（同理，避免闪回主题原字色）
applyStoredTextColors();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
